// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"1ee6ca15","74":"43e36767","215":"26080121","244":"fcb81c88","256":"ddb94b01","295":"e508af19","385":"c5377156","488":"29a96d24","521":"5a67aa72","596":"00dc51c0","739":"9493267b","889":"18881fae","975":"856af4d3"}[chunkId] + ".chunk.js";
};